export default "__VITE_ASSET__Bd9N4_zi__"